import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Advocate_INFJ_personality_header from '../../images/personality_types_details/diplomats_Advocate_INFJ_personality_header.svg'
import diplomats_Advocate_INFJ_conclusion from '../../images/personality_types_details/diplomats_Advocate_INFJ_conclusion.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const infj_conclusion = () => {
    return (
        <Layout>
            <main className="q-td analyst advocate">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/advocate-infj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infjs-at-work" className="tab with-progress">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-conclusion" className="tab with-progress active">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat advocate">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Advocate_INFJ_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Advocate</span> Personality</h1>
                        <div class="code">INFJ-A / INFJ-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>



                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/advocate-infj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infjs-at-work">Workplace Habits</Link></li>
                                <li className="active"><Link to="/personality-types/advocate-infj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Conclusion</h1>


                        <blockquote><p>“In the end, it’s your actions, how you respond to circumstance, that reveals your character.”</p> <footer>Cate Blanchett</footer></blockquote>

                        <p>Few personality types are as passionate and enigmatic as Advocates (INFJs). As someone with this personality type, you stand out for your imagination, your compassion, your integrity, and your deeply held principles. Unlike many other idealistic types, however, you are also capable of turning your ideals into plans and executing them.</p>

                        <p>Yet Advocates face challenges too. Even the most idealistic and dedicated of personality types can become frustrated when it comes to navigating interpersonal conflicts, confronting unpleasant facts, pursuing self-realization, or finding a fulfilling career path. As a result, you may sometimes find yourself questioning who you really are – and who you’re really meant to be.</p>

                        <div class="scene"><img alt="Advocate (INFJ) personality" src={diplomats_Advocate_INFJ_conclusion} /></div>

                        <p>What you have read so far is just an introduction – and it represents less than five percent of what we can tell you about the Advocate personality type. You may have muttered to yourself, “Wow, this is so accurate, it’s creepy,” or “They know more about me than the people I’m closest to do.” You may even be a little uncomfortable, because you’re not used to being so deeply understood.</p>

                        <p>This is not a trick. You felt understood because you were. We’ve spent years studying Advocates’ life stories, experiences, and responses to hundreds of our surveys. Step by step, insight by insight, we discovered exactly how Advocates think and what they need to reach their full potential.</p>

                        <p>This is how we know that many of the challenges you’ve faced (and will face in the future) have been overcome by other Advocates. You are not alone in this. You simply need to learn from the mistakes and successes of others.</p>

                        <p>But in order to do that, you need a road map that fits your needs. Life is too short to stumble around grasping at scattered and contradictory advice that might work for 95% of the population, but not for you. We now need to go much deeper into the Advocate mind and answer, “Why?” “How?” and “What if?”</p>

                        <p>Are you ready to learn why, as an Advocate, you act the way you do? How you can face your fears and go after the goals you secretly dream about? What if you could unlock your true, exceptional potential, while also staying true to who you are?</p>

                        <p>Our Premium Profile provides a road map toward a more focused, confident, and successful you. It’s not for everyone – you need to be willing to challenge yourself, to face your fears, and to ask and answer questions that you haven’t asked yourself before. This is not a quick-fix solution or an easy shortcut. Our goal is to help you grow and become the person you are meant to be, not to simply give you a comfortable mask to put on.</p>

                        <p>Are you ready to begin your journey? Then continue to the next section. We’ll be waiting for you.</p>

                        <div class="number">08</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/advocate-infjs-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/' className='next-feature'>
                            Premium Profile
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default infj_conclusion
